import { EntityFieldTypes, useAuth } from "@emberly/zenith-client";
import axios from "axios";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useStation } from "../providers/StationProvider";

export default function useContactFields() {
  const { t, i18n } = useTranslation();
  const { getAccessTokenSilently } = useAuth();
  const { exportSettings } = useStation();

  const getCustomerNumbers = useCallback(async () => {

      try {

        const res = await axios.post("/api/contact/customernumber/next", {
          upperLimit: exportSettings?.customerNumberUpperLimit,
          lowerLimit: exportSettings?.customerNumberLowerLimit
        }, {
          headers: { Authorization: `Bearer ${await getAccessTokenSilently()}` },
        });

        if (!!res.data && res.status === 200 && typeof res.data.customerNumber === "number") {
          return [res.data.customerNumber];
        } else {
          return null;
        }

      } catch (err) {
        console.log(err);
        return null;
      }
    

  }, [getAccessTokenSilently, exportSettings]);



  const fields = useMemo(() => [
    { name: t("contactRegister:fieldContactHeader"), type: EntityFieldTypes.Header },
    { name: t("common:name"), path: "name", type: EntityFieldTypes.String, required: true },
    { name: t("entity:location:address"), path: "location", type: EntityFieldTypes.Address },
    { name: t("common:email"), path: "email", type: EntityFieldTypes.String, dataType: "email" },
    { name: t("entity:contact:phoneNumber"), path: "phoneNumber", type: EntityFieldTypes.String },
    { name: t("entity:contact:organizationNumber"), path: "organizationNumber", type: EntityFieldTypes.String },
    { name: t("entity:contact:description"), path: "description", type: EntityFieldTypes.String, multiline: true },
    { name: t("contactRegister:fieldStandardAgreement"), path: "standardAgreement", type: EntityFieldTypes.Search, entityType: "Agreement", searchPath: "name", valueGetter: v => ({ id: v.id, name: v.name }) },
    { type: EntityFieldTypes.Divider },
    { name: t("contactRegister:fieldCustomerHeader"), type: EntityFieldTypes.Header },
    { name: t("entity:order:customer"), path: "isCustomer", type: EntityFieldTypes.Boolean },
    {
      name: t("entity:contact:customerNumber"),
      path: "customerNumber",
      type: EntityFieldTypes.String,
      dataType: "number",
      numberType: "int",
      serialization: "number",
      activeIfPath: "isCustomer",
      getSuggestions: getCustomerNumbers,
      suggestionsTitle: t("contactRegister:customerNumberSuggestion"),
      required: true
    },
    { name: t("entity:location:country"), path: "billing.country", type: EntityFieldTypes.Country, activeIfPath: "isCustomer", defaultValue: i18n.language.toUpperCase() },
    { name: t("contactRegister:fieldBillingAddress"), path: "billing.address", type: EntityFieldTypes.String, activeIfPath: "isCustomer" },
    { name: t("contactRegister:fieldBillingAddress2"), path: "billing.address2", type: EntityFieldTypes.String, activeIfPath: "isCustomer" },
    { name: t("contactRegister:fieldPostNumber"), path: "billing.postNumber", type: EntityFieldTypes.String, xs: 5, activeIfPath: "isCustomer" },
    { name: t("contactRegister:fieldArea"), path: "billing.area", type: EntityFieldTypes.String, xs: 7, activeIfPath: "isCustomer" },
    { name: t("contactRegister:fieldBillingEmail"), path: "billing.email", type: EntityFieldTypes.String, activeIfPath: "isCustomer", dataType: "email" },
  ], [t, i18n, getCustomerNumbers]);

  return fields;
}